import { API_endpoints } from "../config";

export const openWorkDay = async (dayName: string) => {
    try {
        const response = await fetch(API_endpoints.openWorkDay, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({ 'dayName': dayName }),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Laden von Daten.");
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Fehler beim Laden von werktag Daten::", error);
        throw error;
    }
};
